import { render, staticRenderFns } from "./BoardSelector.vue?vue&type=template&id=1ea6f366&scoped=true&"
import script from "./BoardSelector.vue?vue&type=script&lang=js&"
export * from "./BoardSelector.vue?vue&type=script&lang=js&"
import style0 from "./BoardSelector.vue?vue&type=style&index=0&id=1ea6f366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6f366",
  null
  
)

export default component.exports